const menu = [
  {
    path: '/index',
    name: 'Index',
    icon: 'icon-createtask_fill',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  },
  {
    path: '/add',
    name: 'Add',
    icon: 'icon-addpeople_fill',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  },
  {
    path: '/workspace',
    name: 'Workspace',
    icon: 'icon-falvsolid',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  },
  {
    path: '/training',
    name: 'Training',
    icon: 'icon-decoration_fill',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  }
  // {
  //   path: '/',
  //   name: '列表页',
  //   icon: 'icon-createtask_fill',
  //   level: 0,
  //   fixed: false,
  //   children: [
  //     {
  //       path: '/chart',
  //       name: 'chart',
  //       icon: 'icon-dynamic_fill',
  //       level: 1,
  //       children: [],
  //       fixed: false
  //     },
  //     {
  //       level: 1,
  //       path: '/icon',
  //       name: 'icon',
  //       children: [],
  //       fixed: false,
  //       icon: 'icon-emoji_fill'
  //     },
  //     {
  //       level: 1,
  //       path: '/filter',
  //       name: 'filter',
  //       children: [],
  //       fixed: false,
  //       icon: 'icon-emoji_fill'
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '页面',
  //   level: 0,
  //   icon: 'icon-manage_fill',
  //   fixed: false,
  //   children: [
  //     {
  //       level: 1,
  //       path: '/error404',
  //       children: [],
  //       fixed: false,
  //       name: '404'
  //     },
  //     {
  //       level: 1,
  //       path: '/notfound',
  //       children: [],
  //       fixed: false,
  //       name: 'Not found'
  //     },
  //     {
  //       level: 1,
  //       path: '/login',
  //       children: [],
  //       fixed: false,
  //       name: '登录'
  //     },
  //     {
  //       level: 1,
  //       path: '/register',
  //       children: [],
  //       fixed: false,
  //       name: '注册'
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '产品',
  //   level: 0,
  //   icon: 'icon-manage_fill',
  //   fixed: false,
  //   children: [
  //     {
  //       path: '/collection',
  //       name: '采集',
  //       icon: 'icon-dynamic_fill',
  //       level: 1,
  //       children: [],
  //       fixed: false
  //     },
  //     {
  //       level: 1,
  //       path: '/transport',
  //       children: [],
  //       fixed: false,
  //       name: '运输'
  //     },
  //     {
  //       level: 1,
  //       path: '/process',
  //       children: [],
  //       fixed: false,
  //       name: '产品'
  //     }
  //   ]
  // },
  // {
  //   path: '/index',
  //   name: '123',
  //   icon: 'icon-wujiaoxing',
  //   // hidden: true,
  //   level: 0,
  //   sort: 1,
  //   children: [],
  //   fixed: false
  // },
  // {
  //   path: '/index',
  //   name: '123',
  //   icon: 'icon-wujiaoxing',
  //   // hidden: true,
  //   level: 0,
  //   sort: 1,
  //   children: [],
  //   fixed: false
  // }

]

export default menu



// WEBPACK FOOTER //
// ./src/router/menu.js